import { render, staticRenderFns } from "./BirthdayItem.vue?vue&type=template&id=2b5e3734&scoped=true&"
import script from "./BirthdayItem.vue?vue&type=script&lang=js&"
export * from "./BirthdayItem.vue?vue&type=script&lang=js&"
import style0 from "./BirthdayItem.vue?vue&type=style&index=0&id=2b5e3734&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5e3734",
  null
  
)

export default component.exports